import { createBrowserRouter, Navigate } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import { Spin } from 'antd'
import Layout from '@/components/Layout'
import AuthGuard from '../components/AuthGuard'

// 从各模块导入路由
import loadRouteModules from '@/router/loadModules'

// 懒加载简单页面
const Login = lazy(() => import('@/pages/Login'))
const NotFound = lazy(() => import('@/pages/NotFound'))

// 路由配置（聚合模块）
export const routes = [
  {
    path: '/login',
    element: <Login />,
    meta: { title: '登录', hidden: true },
  },
  {
    path: '/',
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      // 自动加载 modules 目录下的路由模块
      ...loadRouteModules(),
    ],
  },
  { path: '*', element: <NotFound />, meta: { title: '404', hidden: true } },
]

// 创建路由实例
const router = createBrowserRouter(routes)

// 路由包装组件，用于处理懒加载
const RouteWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense
    fallback={
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    }
  >
    {children}
  </Suspense>
)

export default router
